import {
    request,
    requestPublic
} from './request.js'
// 模板信息分页 
export function getTemplate(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/Template/GetTemplates',
        method: 'get',
        params: {
            Title: obj.title,
            Classs: obj.class
        }
    })
}

// 添加模板文件 
export function addTemplate(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Template/AddTemplate',
        method: 'post',
        data: data
    })
}


// 编辑模板文件 
export function editTemplate(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Template/EditTemplate',
        method: 'post',
        data: data
    })
}

// 删除模板文件 
export function deleteTemplate(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Template/DeleteTemplate',
        method: 'post',
        params: {
            id: id
        }
    })
}


// 获取模板文件详情 
export function getTemplateDetail(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Template/GetTemplateDetail',
        method: 'get',
        params: {
            id: id
        }
    })
}

// 恢复模板文件 
export function revertTemplate(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Template/RevertTemplate',
        method: 'post',
        params: {
            id: id
        }
    })
}

// 发布当前的模板 
export function publishTemplate(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Template/PublishTemplate',
        method: 'post',
        params: {
            id: id
        }
    })
}

// 获取全部模板文件类别
export function getAllClasses() {
    return request({
        url: '/api2/ZsbSiteAdmin/Template/GetAllClasses',
        method: 'get',
    })
}